import React, { Component, PropTypes } from 'react';
import {reduxForm} from "redux-form";
import {EditLang, DeleteLang, GetOneLanguage, AddLang} from '../../actions/index';
import {Link} from 'react-router';
import FileInput from 'react-file-input';


class AllLanguageEdit extends Component {
    static contextTypes = {
        router: PropTypes.object,
        fields: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state = {
            upload: false,
            img: '',
            addAnother: false
        }
        this.delLang = this.delLang.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.delLangOpenModal = this.delLangOpenModal.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        if(this.props.params.id){
            this.props.GetOneLanguage(this.props.params.id, token)
        }
    }
    componentDidMount(){
        this.setState({
            img: this.props.fields.flag.value
        })
    }
    delLang(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DeleteLang(this.props.params.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.context.router.push('/language/all');
            }
        });
    }
    delLangOpenModal(){
        let token = localStorage.getItem('id_token_admin');
        $('#DelLang').modal('show');
    }
    closeModal(){
        $('#DelLang').modal('hide');
        this.props.lang.lang_one = {};
    }
    handleChange(event) {
        let obj = event.target.files[0];
        this.props.fields.flag.onChange(obj);

        this.setState({
            img: obj.name
        })
    }
    SubmitForm(props, e){
        let token = localStorage.getItem('id_token_admin');
        if(this.props.params.id){
            this.props.EditLang(this.props.params.id, props, token).then((response)=>{
                if(response.payload.status == 200){
                    this.context.router.push('/language/all');
                }
            });
        }else{
            if(props.add == 'true'){
                delete props.add
                this.props.AddLang(token, props).then((response)=>{
                    if(response.payload.status == 201){
                        window.location.reload();
                    }
                });
            }else{
                this.props.AddLang(token, props).then((response)=>{
                    if(response.payload.status == 201){
                        this.context.router.push('/language/all');
                    }
                });
            }

        }
    }
    componentWillUnmount(){
        this.props.lang.lang_one = {};
        this.props.lang.error_lang = {};
    }
    render() {
        const { fields: {
            name,
            flag,
            code}, handleSubmit} = this.props;
        return (
            <div className="dashboard-wrapper">
                {this.props.params.id ? <p className="dashboard-title">{this.props.lang.lang_one.name} </p> : <p className="dashboard-title">Add Language</p>}
                <form id="addLangForm" onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="name">Name</label>
                                </div>
                                <div className={ name.touched && !name.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <input type="text"
                                           placeholder="Name"
                                           className="form-control"
                                           name="name"
                                           id="name"
                                        {...name}
                                    />
                                </div>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="flag">Flag</label>
                                </div>
                                <div className={ flag.touched && !flag.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                    <label htmlFor="flag" className="btn btn-primary pull-left">Выбрать</label>
                                    <input type="file"
                                           style={{display: 'none'}}
                                           name="flag"
                                           id="flag"
                                           onChange={this.handleChange}
                                    />
                                    <input type="text"
                                           placeholder="Flag"
                                           className="form-control"
                                           name="flag2"
                                           id="flag2"
                                           disabled
                                           value = {this.state.img || flag.value}
                                    />
                                </div>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="code">Code</label>
                                </div>
                                <div className={ code.touched && !code.valid ? 'col-md-4 has-error' : 'col-md-4'}>

                                    <input type="text"
                                           placeholder="Code"
                                           className="form-control"
                                           name="code"
                                           id="code"
                                           maxLength="2"
                                        {...code}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            {this.props.lang.error_lang && this.props.lang.error_lang.response && this.props.lang.error_lang.response.data.code ? <p className="error-p"> {this.props.lang.error_lang.response.data.code[0]} </p> : ""}
                            <div className="col-md-12 text-center button-group">
                                <Link to={"language/all"} className="btn btn-default">Back</Link>
                                {this.props.params.id ?
                                    <button onClick={this.delLangOpenModal} type="button" className="btn btn-danger">Delete</button>
                                    :
                                    <button type="submit" onClick={handleSubmit(values =>
                                          this.SubmitForm({
                                            ...values,
                                            add: 'true'
                                          }))}
                                            className="btn btn-info">Save and add another</button>
                                }
                                <button type="submit" className="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="modal fade" id="DelLang" tabIndex="-1" role="dialog" aria-labelledby="DelLangLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelLang"></span>
                                <p>Do you really want to delete this language {this.props.lang.lang_one ? <span>{this.props.lang.lang_one.name}</span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delLang} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}
// <FileInput name="flag"
//                                           id="flag"
//                                           accept=".png,.gif"
//                                           placeholder="My Image"
//                                           className="form-control"
//                                           onChange={this.handleChange} />

function validate(values) {
    const errors = {};
    if(!values.name){
        errors.name = 'Enter a name'
    }
    if(!values.flag){
        errors.flag = 'Enter a flag'
    }
    if(!values.code){
        errors.code = 'Enter a code'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        lang: state.lang,
        initialValues: {
            name: state.lang.lang_one.name || '',
            flag: state.lang.lang_one.flag || '',
            code: state.lang.lang_one.code || ''
        }
    }
}
export default reduxForm({
    form: 'Edit Language',
    fields: ['name', 'flag', 'code'],
    validate
}, mapStateToProps, {EditLang, DeleteLang, GetOneLanguage, AddLang})(AllLanguageEdit);



// WEBPACK FOOTER //
// ./src/components/language/allEdit.js